import {LabelAndKey} from "./types/LabelAndKey";
import _ from "lodash";
import {notification} from "antd";
import {FormInstance} from "antd/lib/form";
import React from "react";

export const showWarning = (fieldName: string, codes: string) => {
    notification["warning"]({
        message: fieldName,
        description: `These codes were not matched: ${codes}`,
        duration: 0,
        placement: "topLeft"
    })
}

export const fieldsWithErrors = (form: FormInstance) => {
    return _.keys(form.getFieldsValue())
        .filter(fieldName => form.getFieldError(fieldName).length > 0) as string[]
}

export const validateFieldsWithErrors = (form: FormInstance) => {
    const errorFields = fieldsWithErrors(form)
    if (!form.isFieldsValidating(errorFields)) {
         form.validateFields(errorFields)
    }
}

const lengths = (choices: LabelAndKey[]) => {
    return _.uniq(choices.map(i => i.key.length))
}

export const handlePaste = (
    event: React.ClipboardEvent<HTMLTextAreaElement>,
    form: FormInstance,
    fieldId: string,
    fieldLabel: string,
    fieldLabelFunction: (e: LabelAndKey) => string,
    choices: LabelAndKey[]
): void => {
    const pastedText = event.clipboardData.getData('Text');
    const keyLengths = lengths(choices)
    const keys = pastedText
        .split(',')
        .map(s => s.trim().toUpperCase())
        .filter(i => keyLengths.includes(i.length))

    const currentValue = form.getFieldValue(fieldId)
    let newValue: LabelAndKey[] = []
    if (currentValue) {
        newValue = JSON.parse(JSON.stringify(currentValue))
    }
    if (newValue) {
        const matched = keys.flatMap(i => {
            return choices
                .filter(j => j.key === i)
                .map(j => {
                    return {
                        key: j.key,
                        label: fieldLabelFunction(j)
                    }
                })
        })

        const matchedKeys = matched.map(i => i.key)
        const unmatchedKeys = keys.filter(i => !matchedKeys.includes(i))
        newValue.push(...matched)
        form.setFieldsValue({[fieldId]: _.uniqBy(newValue, 'key')})
        validateFieldsWithErrors(form)
        if (unmatchedKeys && unmatchedKeys.length > 0) {
            showWarning(fieldLabel, unmatchedKeys.join(", "))
        }
    }
}